module.exports = __webpack_public_path__ + "static/img/bg-fr.e5481953.png";